<template>
  <div>
    <v-card>
      <v-toolbar dense color="grey lighten-3" flat>
        <v-icon>mdi-magnify</v-icon>
        <v-toolbar-title>GL Account No. Helplist</v-toolbar-title>
        <v-spacer></v-spacer>
        <v-btn text icon @click="doCancel">
          <v-icon>mdi-close</v-icon>
        </v-btn>
      </v-toolbar>
      <v-card-text>
        <v-card>
          <v-card-title>
            <v-text-field append-icon="mdi-magnify" label="Search" single-line hide-details v-model="search"></v-text-field>
            <v-spacer></v-spacer>
            <v-flex class="mt-3" xs12>
              <message :messages="messages"></message>
            </v-flex>
          </v-card-title>
          <v-card-text>
            <v-data-table
            :headers="headers"
            :items="items"
            :loading="loading"
            :custom-filter="customSearch"
            :no-data-text="noDataText"
            item-key="key"
            v-bind:search="search"
            v-model="selected"
            >
            <template v-slot:item="row">
              <tr>
                <td class="text-xs-left">{{ row.item.glAcctNo }}</td>
                <td class="text-xs-left">{{ row.item.description }}</td>
                <td style="text-align:center">
                  <v-btn icon color="primary" text type="submit" @click.prevent="doSelect(row.item)">
                    <v-icon>mdi-content-copy</v-icon>
                  </v-btn>
                </td>
              </tr>
            </template>
            </v-data-table>
          </v-card-text>
        </v-card>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import { extractMenu } from '@/utils/extract'
import * as TableConst from '@/mixins/table'
import MessageMixin from '@/mixins/message'
import { expandURI } from '@/utils/ajax'

export default {
  data() {
    return {
      headers: [
        { text: 'GL Acct No.', value: 'glAcctNo' },
        { text: 'Description', value: 'description' },
        { text: 'Action', value: 'action', align: 'center', sortable: false }
      ],
      selected: []
    }
  },
  mounted() {
    this.doInit()
  },
  computed: {
    rptMenu() {
      return this.$store.state.reports.accountReports.menu
    }
  },
  methods: {
    async doInit() {
      try {
        await this.$store.dispatch('accountReportsInit')
        const apiURI = this.rptMenu.acctGL
        const result = await this.$http.get(apiURI)
        if (result.data) {
          const { data } = result
          if (data) {
            // return as a menu list
            this.menu = extractMenu(result.data._links)
            if (this.menu) {
              this.doFetchGLAcctNo()
            }
          }
        }
      } catch (err) {
        throw err
      }
    },
    async doFetchGLAcctNo() {
      const apiURI = this.menu.getGLAcctNoList
      if (apiURI) {
        this.loading = true
        const expand = {
          branch: this.brn,
          fund: this.fund,
          suffix: this.suffix,
          acctType: this.acctType,
          postType: this.postType,
          acctYear: this.acctYr
        }
        this.$http.get(expandURI(apiURI, expand)).then(result => {
          this.items = []
          const { data } = result.data
          if (data) {
            data.map(acctNoList => {
              const convertList = {
                glAcctNo: acctNoList.value,
                description: acctNoList.label
              }
              this.items.push(convertList)
            })
          }
          this.loading = false
        }).catch(err => {
          this.loading = false
          const { data } = err.response
          if (data) {
            this.message(data)
            this.fieldMessage(data)
          }
        })
      }
    },
    doSelect(data) {
      const acctNoObj = {
        selectedItem: data.glAcctNo,
        totalLength: this.items.length,
        from: this.wAcctNo
      }
      this.$emit('doAssign', acctNoObj)
      this.$emit('close')
    },
    selectData(data) {
      this.selected = []
      const resultList = {
        glAcctNo: data.glAcctNo,
        description: data.description
      }
      this.selected.push(resultList)
    },
    doCancel() {
      this.$emit('close')
    }
  },
  watch: {
    'changeValue': function(value) {
      this.doFetchGLAcctNo()
    }
  },
  mixins: [
    TableConst.default,
    MessageMixin
  ],
  props: {
    brn: {
      type: String,
      default: ''
    },
    fund: {
      type: String,
      default: ''
    },
    suffix: {
      type: String,
      default: ''
    },
    acctType: {
      type: String,
      default: ''
    },
    postType: {
      type: String,
      default: ''
    },
    acctYr: {
      type: Number,
      default: 0
    },
    changeValue: {
      type: String,
      default: ''
    },
    wAcctNo: {
      type: String,
      default: ''
    }
  }
}
</script>
